/**
 * Development-only log of endpoint activity, e.g. `logApi("Users", "login", "response", data)`.
 * `type` is "response" for a raw payload or "parsed" for a validation result, which colours
 * itself by `data.success`; anything else is a custom label.
 */
export const logApi = (endpoint: string, method: string, type: string, data: any) => {
  if (import.meta.env.DEV) {
    let emoji = "📊";
    let color = "#9ca3af"; // default gray

    if (type === "parsed") {
      emoji = "✅";
      color = data?.success === false ? "#ef4444" : "#22c55e"; // red if false, green otherwise
    } else if (type === "response") {
      emoji = "📥";
      color = "#3b82f6"; // blue
    }

    const message = `${emoji} %c${endpoint}.${method}.${type}:\n`;
    const style = `color: ${color}; font-weight: bold;`;

    console.log(message, style, data);
  }
};
